/**
 * PersonScorecard - Detail panel for a selected person node.
 * Shows tabs: Behavioral | Connections | History
 */

import React, { useState } from 'react';
import { Box, Typography, Avatar, IconButton, Tabs, Tab } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { ZONE_CONFIG } from '../../constants/dashboardConfig';
import { getInitials } from '../../utils/networkUtils';
import BehavioralTab from './BehavioralTab';
import SnaMetricsTab from './SnaMetricsTab';
import HistoryTab from './HistoryTab';

function PersonScorecard({ node, entityId, onClose }) {
  const [tabValue, setTabValue] = useState(0);
  const zoneConf = ZONE_CONFIG[node.zone];

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Header */}
      <Box
        sx={{
          p: 2.5,
          background: 'linear-gradient(135deg, #100331 0%, #1a0845 100%)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexShrink: 0,
        }}
      >
        <Avatar
          sx={{
            width: 56,
            height: 56,
            bgcolor: zoneConf?.color || '#767676',
            fontSize: '1.2rem',
            fontWeight: 700,
            boxShadow: '0 0 0 3px rgba(255,255,255,0.2)',
          }}
        >
          {getInitials(node.label)}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }} noWrap>
            {node.label}
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(201,160,220,1)' }}>
            {zoneConf?.label || 'Network'} Zone
          </Typography>
          {!node.nameResolved && (
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>
              Hash ID - name unavailable
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Tabs */}
      <Tabs
        value={tabValue}
        onChange={(e, v) => setTabValue(v)}
        sx={{
          minHeight: 40,
          flexShrink: 0,
          '& .MuiTab-root': { minHeight: 40, fontSize: '0.75rem', textTransform: 'none' },
        }}
      >
        <Tab label="Behavioral" />
        <Tab label="Connections" />
        <Tab label="History" />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {tabValue === 0 && (
          <BehavioralTab node={node} entityId={entityId} />
        )}
        {tabValue === 1 && (
          <SnaMetricsTab node={node} entityId={entityId} />
        )}
        {tabValue === 2 && (
          <HistoryTab node={node} entityId={entityId} />
        )}
      </Box>
    </Box>
  );
}

export default PersonScorecard;
